import { registerPlugin } from '@capacitor/core';
import { UPIApp } from './definitions';
const CFBridge = registerPlugin('CFBridge', {
    web: () => import('./web').then(m => new m.CFBridgeWeb()),
});
export * from './definitions';
// noinspection SuspiciousTypeOfGuard
class CFPaymentService {
    // eslint-disable-next-line @typescript-eslint/ban-types
    async startPaymentWEB(params) {
        if (params instanceof Map) {
            try {
                return CFBridge.startPaymentWEB(CFPaymentService.strMapToObj(params));
            }
            catch (e) {
                return Promise.reject(e);
            }
        }
        else {
            if (params instanceof Object) {
                try {
                    return CFBridge.startPaymentWEB(params);
                }
                catch (e) {
                    return Promise.reject(e);
                }
            }
            else {
                return Promise.reject('Please send a valid params format');
            }
        }
    }
    // noinspection SuspiciousTypeOfGuard
    // eslint-disable-next-line @typescript-eslint/ban-types
    async startPaymentUPI(params) {
        if (params instanceof Map) {
            try {
                return CFBridge.startPaymentUPI(CFPaymentService.strMapToObj(params));
            }
            catch (e) {
                return Promise.reject(e);
            }
        }
        else {
            if (params instanceof Object) {
                try {
                    return CFBridge.startPaymentUPI(params);
                }
                catch (e) {
                    return Promise.reject(e);
                }
            }
            else {
                return Promise.reject('Please send a valid params format');
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    async getUPIApps() {
        const result = await CFBridge.getUPIApps();
        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const upiApps = result.apps;
            return Promise.resolve(upiApps);
        }
        catch (e) {
            return Promise.reject(e);
        }
    }
    getIcon(base64String) {
        return `data:image/png;base64,${base64String}`;
    }
    transFormUPIResponse(result) {
        const array = [];
        result.forEach(function (item) {
            array.push(new UPIApp(item.id, item.displayName, item.icon));
        }, this);
        return array;
    }
    static strMapToObj(strMap) {
        const obj = Object.create(null);
        for (const [k, v] of strMap) {
            // We don’t escape the key '__proto__'
            // which can cause problems on older engines
            obj[k] = v;
        }
        return obj;
    }
}
const CFPaymentServiceInstance = new CFPaymentService();
export { CFPaymentServiceInstance };
//# sourceMappingURL=index.js.map